// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3ChBz","item":"PaymentsMobile_item__3o35h","label":"PaymentsMobile_label__nLLb0","amount":"PaymentsMobile_amount__2RdPY"};